import { createSlice } from "@reduxjs/toolkit";

const initialLeaderboardState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  exportData: [],
  countryList: [],
  usersCount: null,
  allCountryList: null,
  newLeaderboard: {},
  LeaderboardForEdit: {},
  itemLeaderboard: {},
  deleteLeaderboard: {},
 
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const Slice = createSlice({

  name: "Leaderboard",
  initialState: initialLeaderboardState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    emptyList: (state, action) => {
      state.error = null;
      state.entities = [];
      // state.totalCount = 0;
      state.exportData = [];
    },
    LeaderboardList: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    createLeaderboard: (state, action) => {
      const { newLeaderboard } = action.payload;
      state.error = null;
      state.newLeaderboard = newLeaderboard;
    },
    deleteLeaderboard: (state, action) => {
      const { deleteLeaderboard } = action.payload;
      state.error = null;
      state.deleteLeaderboard = deleteLeaderboard;
    },
    singleItemFetched: (state, action) => {
      state.actionsLoading = false;
      state.LeaderboardForEdit = action.payload.LeaderboardForEdit;
      state.error = null;
    },

  }
});
